import { render, staticRenderFns } from "./FacilityInfrastructure.vue?vue&type=template&id=5abfda07&scoped=true&"
import script from "./FacilityInfrastructure.vue?vue&type=script&lang=js&"
export * from "./FacilityInfrastructure.vue?vue&type=script&lang=js&"
import style0 from "./FacilityInfrastructure.vue?vue&type=style&index=0&id=5abfda07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abfda07",
  null
  
)

export default component.exports